<ion-card color="light" class="my-item ion-no-margin">
  <ion-grid *ngIf="selectOrder" class="ion-no-padding">
    <ion-row class="ion-padding-horizontal">
      <ion-col size="12" *ngIf="selectOrder?.pickupPerson">
        <ion-text color="medium" class="label">Pickup Person</ion-text><br />
        <div class="person-details">
          <ion-icon name="contact" class="icon-padding" color="dark"></ion-icon>
          <ion-text color="dark" class="font-bold">{{
            selectOrder?.pickupPerson?.userName
          }}</ion-text>
          <ion-button
            size="small"
            color="medium"
            *ngIf="
              selectOrder?.orderType !== 'DROP' &&
              statusFilter(['CREATED', 'PICKUP_SCHEDULED'], true)
            "
          >
            <ion-text
              class="ion-text-uppercase"
              color="light"
              (click)="selectPickupExecutive()"
              >Change</ion-text
            >
          </ion-button>
        </div>
      </ion-col>
      <ion-col size="12" *ngIf="!selectOrder?.saleOrder">
        <ion-text
          color="medium"
          class="label"
          *ngIf="!selectOrder?.saleOrder && selectOrder?.orderType === 'PICKUP'"
          >pickup date</ion-text
        >
        <ion-text
          color="medium"
          class="label"
          *ngIf="!selectOrder?.saleOrder && selectOrder?.orderType === 'DROP'"
          >drop date</ion-text
        >
        <br />
        <ion-text
          color="dark"
          *ngIf="!selectOrder?.saleOrder && selectOrder?.orderType === 'PICKUP'"
          >{{
            selectOrder?.timeSlot?.startTime
              | date: "dd-MMM-yy hh:mm a" || "---"
          }}
        </ion-text>
        <ion-text
          color="dark"
          *ngIf="
            !selectOrder.isEdit &&
            !selectOrder?.saleOrder &&
            selectOrder?.orderType === 'DROP'
          "
          >{{ selectOrder?.orderDate | date: "dd-MMM-yy hh:mm a" || "---" }}
        </ion-text>
        <ion-icon
          *ngIf="
            !selectOrder.isEdit &&
            selectOrder.orderType === 'DROP' &&
            selectOrder?.payment?.orderPaymentStatus !== 'COMPLETED'
          "
          color="dark"
          name="create"
          class="icon-size cursor-pointer"
          (click)="selectOrder.isEdit = true; openCalendar($event)"
        ></ion-icon>
        <p-calendar
          #calendar
          [hidden]="!selectOrder.isEdit"
          [(ngModel)]="selectedOrderDate"
          [maxDate]="maxDateValue"
          [readonlyInput]="true"
          (onSelect)="onSelectCal()"
          (onClose)="selectOrder.isEdit = false"
          appendTo="body"
        ></p-calendar>
      </ion-col>
      <ion-col size="12">
        <ion-text color="medium" class="ion-text-uppercase text-small font-bold"
          >order created on</ion-text
        >
        <br />
        <ion-text color="dark">{{
          selectOrder?.createdDate | date: "dd-MMM-yy hh:mm a" || "---"
        }}</ion-text>
      </ion-col>
      <ion-col size="12" *ngIf="selectOrder?.saleOrder">
        <ion-text color="medium" class="ion-text-uppercase text-small font-bold"
          >dispatched location from</ion-text
        >
        <br />
        <ion-text
          color="dark"
          [title]="selectOrder?.fromLocation?.addressInfo | address"
          class="text-regular address-box line-2"
          >{{ selectOrder?.fromLocation?.addressInfo | address }}</ion-text
        >
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-card>
